export const ONLY_AUTORIZED = true;
export const DEFAULT_LOCALE = 'ru_RU';
export const DEFAULT_LOCALE_SHORT = 'ru';
// export const DEFAULT_LOCALE_SHORT = 'en';
export const DASHBOARD_PAGE = '/dashboard/';
export const HIDE_SYSTEM_ROUTE = true;

// const defaultDomainName = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_NAME ? window.APP_DOMAIN_NAME : (process.env.REACT_APP_DOMAIN_NAME || '0.0.0.0');
const defaultDomainName = window.location.hostname;
const defaultPort = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_PORT ? window.APP_DOMAIN_PORT : (process.env.REACT_APP_DOMAIN_PORT || 8080);
const defaultWSPort = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_WS_PORT ? window.APP_DOMAIN_WS_PORT : (process.env.REACT_APP_DOMAIN_WS_PORT || 8080);
const isSecurePage = window.location.protocol === 'https:';
const configuredProtocol = process.env.NODE_ENV === 'production' && window.APP_DOMAIN_PROTOCOL ? window.APP_DOMAIN_PROTOCOL : (process.env.REACT_APP_DOMAIN_PROTOCOL || 'http');
const defaultProtocol = isSecurePage ? 'https' : configuredProtocol;
const entryPoint = process.env.NODE_ENV === 'production' && window.APP_ENTRY_POINT ? window.APP_ENTRY_POINT : (process.env.REACT_APP_ENTRY_POINT || '');
const defaultUrl = isSecurePage ? window.location.origin : `${defaultProtocol}://${defaultDomainName}:${defaultPort}`;
const buildVersion = process.env.NODE_ENV === 'production' && window.APP_BUILD_VERSION ? window.APP_BUILD_VERSION : (process.env.REACT_APP_BUILD_VERSION || '1.0.0.0.0');

export const BUILD_VERSION = buildVersion;
export const DEFAULT_URL = isSecurePage ? window.location.origin : `${defaultProtocol}://${defaultDomainName}`;
export const WS_URL = isSecurePage ? `${window.location.origin.replace(/^http/, 'ws')}/ws` : `ws://${defaultDomainName}:${defaultWSPort}`;
export const BACKEND_URL = defaultUrl + entryPoint;
export const DOMAIN_NAME = defaultDomainName;
export const DOMAIN_PORT = defaultPort;
export const resolveMediaServerUrl = url => (
  isSecurePage ? `${window.location.origin}${url.replace(/^:\d+/, '')}` : `${DEFAULT_URL}${url}`
);
export const ITEMS_OF_PAGE = [{ value: 5, name: 5 }, { value: 10, name: 10 }, { value: 25, name: 25 }, { value: 50, name: 50 }];
// export const DEFAULT_ITEMS_OF_PAGE = 25;
// export const DEFAULT_ITEMS_OF_PAGE = 10;
export const DEFAULT_ITEMS_OF_PAGE = 10;

export const LOADING_DELAY = 500;

export const DEFAULT_DATE_RANGE_SUBTRACT_COUNT = 1;
export const DEFAULT_DATE_RANGE_SUBTRACT_TYPE = 'month';
// size in byte
export const MAX_UPLOAD_FILE_SIZE = 2 * 1024 * 1024;
export const MAX_UPLOAD_FILE_COUNT = 20;
export const CUSTOMER = process.env.REACT_APP_CUSTOMER || '';
export const CUSTOMER_CITY = process.env.REACT_APP_CUSTOMER_CITY || '';
export const CUSTOMER_PHONE = process.env.REACT_APP_CUSTOMER_PHONE || '';
export const CUSTOMER_EMAIL = process.env.REACT_APP_CUSTOMER_EMAIL || '';
export const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE || '';
export const SUPPORT_MAIL = process.env.REACT_APP_SUPPORT_MAIL || '';

export const STATUS_ENUM = {
  ERROR: 2,
  WARNING: 1,
  GOOD: 0,
};

export const VIOLATION_CODE_ENUM = {
  FREE_PARKING: 400,
  PAID_PARKING: 401,
  PARKING_PROHIBITED: 402,
  PARKING_PROHIBITED_EVEN_DAYS: 403,
  PARKING_PROHIBITED_ODD_DAYS: 404,
  NO_STOPPING: 405,
  PARKING_FOR_HANDICAPPED: 406,
};

export const EXPORT_TYPE_ENUM = {
  FTP: 2,
  DUPLO: 1,
};
